import type { IrremovableFieldsConfig } from '@jira/jql-builder__basic/src/utils/irremovable-fields/index.tsx';

export const RESOURCE_TYPE_NAME = 'calendarFilterFieldResource';
export const PACKAGE_NAME = 'jiraRouterResourcesServicedeskCalendar';
export const TEAM_NAME = 'jsd-shield';

export const REQUEST_TYPE_FILTER = 'request type';
export const SERVICE_DESK_ORIGIN_FILTER = 'service desk origin';
export const SERVICE_DESK_ORIGIN_DUPLICATE_FILTER = 'cf[10010]';
export const RESOURCE_TYPE_FILTER_FIELD = 'RESOURCE_TYPE_FILTER_FIELD';
export const DEFAULT_CALENDAR_FILTER_FIELDS: IrremovableFieldsConfig = ['status', 'assignee'];
